<h1>Offres commerciales</h1>

<div class="text-center grid justify-content-center" *ngIf="api.ebpOffers">
	<ng-container *ngFor="let offer of api.ebpOffers" >
		<div class="sm:col-6 md:col-3 col-12 p-4" [ngClass]="{'hidden': offer && offer.hidden}" >
			<p-image src="https://cdn.blackrockgames.fr/items/{{offer.Id}}/couverture.png?width=800" [preview]="true" imageClass="w-full border-round"></p-image>
			<button label="En profiter" pButton (click)="api.addEbpOffer(offer)" class="w-full"></button>
		</div>
	</ng-container>
	<ng-container *ngFor="let key of api.objectKeys(api.reductions)">
		<div class="sm:col-6 md:col-3 col-12 p-4" >
			<p-image src="/assets/offres/{{key}}.jpg" [preview]="true" imageClass="w-full border-round"></p-image>
			<button label="En profiter" pButton (click)="api.goTo('/games/'+api.returnBtoa({PriceListId:key}))" class="w-full"></button>
		</div>
	</ng-container>
</div>